// extracted by mini-css-extract-plugin
export var container = "feefo-widget-module--container--01aaf";
export var content = "feefo-widget-module--content--50c3a";